var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { HttpClient } from '@angular/common/http';
import { BaseService } from "app/views/base.service";
import { DataProvider2, DataProviderFactory } from "../provider/data2.provider";
var MailService = /** @class */ (function (_super) {
    __extends(MailService, _super);
    function MailService(http, dpf, dp2) {
        var _this = _super.call(this, http) || this;
        _this.http = http;
        _this.dpf = dpf;
        _this.dp2 = dp2;
        _this.mail = _this.dpf.getNew('mail');
        _this.mailStatus = _this.dpf.getNew('mail_status');
        _this.mailer = _this.dpf.getNew('mailer');
        _this.testMail = _this.dpf.getNew('mails/test');
        return _this;
    }
    MailService.prototype.getMailerReportList = function () {
        return this.dp2.get('/mailer/report');
    };
    /**
     *
     * @param fp {FilterParams} Фильтры выборки
     * @param params {Object} Параметры выборки (поля, типы емейлов и т.п.)
     */
    MailService.prototype.addMailerNewReport = function (reportName, fp, params) {
        return this.dp2.post('/mailer/report', __assign({}, fp, { report: __assign({ reportName: reportName }, params) }));
    };
    MailService.prototype.removeMailerReport = function (reportId) {
        return this.dp2.delete('/mailer/report', { reportId: reportId });
    };
    MailService.prototype.sendToMailer = function (report, deliveryId) {
        return this.dp2.post('/mailer', __assign({ deliveryId: deliveryId }, report));
    };
    MailService.prototype.sendTestMail = function (data) {
        return this.dp2.post('/api/mail/sendtest', data);
    };
    MailService.prototype.updateReportStatus = function (reportId, status) {
        return this.dp2.put('/mailer/report', { reportId: reportId, status: status });
    };
    return MailService;
}(BaseService));
export { MailService };
